module.exports = __webpack_public_path__ + "static/media/70.5c020836.jpg";